import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';

import CountrySelect from '../common/CountrySelect';

const propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  variant: PropTypes.oneOf(['phone', 'country']),
};

const CountrySelectField = ({ name, ...props }) => {
  const [field] = useField({ name });

  return (
    <CountrySelect
      {...props}
      name={name}
      variant="country"
      value={field.value}
      onChange={field.onChange}
      onBlur={field.onBlur}
    />
  );
};

CountrySelectField.propTypes = propTypes;

export default CountrySelectField;
